import { icons } from "../../const/icons";
import { TAB_NAMES } from "../../const/inventario";

const INV_NAVIGATION_TABS = [
  {
    id: 1,
    title: TAB_NAMES.items,
    icon: icons.items,
  },
  {
    id: 3,
    title: TAB_NAMES.stores,
    icon: icons.almacenes,
  },
];

export const useNavTabs = () => {
  return INV_NAVIGATION_TABS;
};
